<div class="main-content">
  <h4>{{ 'Confirm your email' | translate }}</h4>
  <p>
    {{ 'We sent you an email at' | translate }}{{ email
    }}{{
      'to verify your email address. Just click on the link and fill in your personal info.'
        | translate
    }}
  </p>
</div>
